// Per-viewer snooze for the non-blocking training reminder banner. Stored in
// localStorage only: it is a convenience, never evidence that training is done,
// and required training (blocking notice / API 423) is not affected.
export const TRAINING_REMINDER_SNOOZE_MS = 60 * 60 * 1000;

const storageKey = (contextKey) => `promang.trainingReminderSnooze:${contextKey}`;

// A new or revised guide changes the signature, so the banner shows again
// immediately instead of waiting out the snooze.
export const trainingReminderSignature = (reminders = []) =>
  reminders.map((item) => `${item.id}:${item.revision_id ?? ''}`).sort().join(',');

export function readTrainingReminderSnooze(contextKey, storage = globalThis.localStorage) {
  try {
    const parsed = JSON.parse(storage?.getItem(storageKey(contextKey)) || 'null');
    if (!parsed || typeof parsed.until !== 'number') return null;
    return { until: parsed.until, signature: String(parsed.signature ?? '') };
  } catch {
    return null;
  }
}

export function writeTrainingReminderSnooze(contextKey, signature, now = Date.now(), storage = globalThis.localStorage) {
  const value = { until: now + TRAINING_REMINDER_SNOOZE_MS, signature };
  try {
    storage?.setItem(storageKey(contextKey), JSON.stringify(value));
  } catch {
    // Blocked storage: the snooze still applies for this page session via state.
  }
  return value;
}

export function isTrainingReminderSnoozed(snooze, signature, now = Date.now()) {
  return Boolean(snooze) && snooze.signature === signature && now < snooze.until;
}
